export default __webpack_public_path__ + "static/media/roobert-regular-webfont.65c9df83.woff";